export var LoaderSize;
(function (LoaderSize) {
    LoaderSize["SIZE14"] = "14";
    LoaderSize["SIZE18"] = "18";
    LoaderSize["SIZE22"] = "22";
    LoaderSize["SIZE38"] = "38";
    LoaderSize["SIZE46"] = "46";
    LoaderSize["SIZE62"] = "62";
})(LoaderSize || (LoaderSize = {}));
//# sourceMappingURL=Loader.enum.js.map